<script lang="ts">
    import { onMount } from "svelte/internal";
    export let value;
    export let id;
    export let label = "";
    export let required: boolean = false;
    export let options = [
        {
            value: 1,
            text: "Sanremasco",
        },
        {
            value: 2,
            text: "Taggiasco",
        },
        {
            value: 3,
            text: "Imperiese",
        },
    ];

    let select_element;
    onMount(() => {
        M.FormSelect.init(select_element, {});
    });
</script>

<select {id} {...$$restProps} required={required} bind:value="{value}" bind:this={select_element}>
    {#each options as opt}
        <option value={opt.value}>{opt.text}</option>
    {/each}
</select>
{#if label}
    <label for={id}>{label}</label>
{/if}
